/**
 * GA4 e-commerce events via GTM dataLayer
 * Events: view_item, add_to_cart, begin_checkout, select_grammage_item
 */

window.dataLayer = window.dataLayer || [];

/* ─── view_item ─────────────────────────────────────────────────────────────
   Pushed by Liquid via window.hb_product on product pages
   ─────────────────────────────────────────────────────────────────────────── */
if (window.hb_product) {
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      currency: window.hb_product.currency,
      value: window.hb_product.price,
      items: [{
        item_id: window.hb_product.sku || String(window.hb_product.variant_id),
        item_name: window.hb_product.title,
        item_variant: window.hb_product.variant_title !== 'Default Title' ? window.hb_product.variant_title : undefined,
        item_category: window.hb_product.category,
        price: window.hb_product.price,
        quantity: 1
      }]
    }
  });
}

/* ─── add_to_cart ───────────────────────────────────────────────────────────
   Intercept fetch calls to /cart/add.js
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  var _lastAddToCartTs = 0;
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0].url || '');
    return originalFetch.apply(this, args).then(function (response) {
      if (url.includes('/cart/add')) {
        response.clone().json().then(function (data) {
          var now = Date.now();
          if (now - _lastAddToCartTs < 500) return;
          _lastAddToCartTs = now;
          const items = data.items || (data.id ? [data] : []);
          if (!items.length) return;
          const value = items.reduce((sum, item) => sum + item.final_line_price / 100, 0);
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: items[0].currency || document.documentElement.lang,
              value: value,
              items: items.map(function (item) {
                return {
                  item_id: item.sku || String(item.variant_id),
                  item_name: item.product_title,
                  item_variant: item.variant_title !== 'Default Title' ? item.variant_title : undefined,
                  item_category: item.product_type,
                  price: item.final_price / 100,
                  quantity: item.quantity
                };
              })
            }
          });
        }).catch(function () {});
      }
      return response;
    });
  };
})();

/* ─── begin_checkout ────────────────────────────────────────────────────────
   Listen for clicks on checkout buttons (cart drawer + cart page)
   ─────────────────────────────────────────────────────────────────────────── */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[name="checkout"], a[href="/checkout"], button[data-checkout]');
  if (!btn) return;

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (!cart.items || !cart.items.length) return;
      const value = cart.total_price / 100;
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: cart.currency,
          value: value,
          items: cart.items.map(function (item) {
            return {
              item_id: item.sku || String(item.variant_id),
              item_name: item.product_title,
              item_variant: item.variant_title !== 'Default Title' ? item.variant_title : undefined,
              item_category: item.product_type,
              price: item.final_price / 100,
              quantity: item.quantity
            };
          })
        }
      });
    })
    .catch(function () {});
});

/* ─── select_grammage_item ─────────────────────────────────────────────────────────
   Track product card interactions:
   - Collection pages: variant <select> change
   - Homepage: "Choose Options" / quick-add button click
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  function getCardData(card) {
    var heading = card.querySelector('.card__heading a');
    var name = heading ? heading.textContent.trim() : '';
    var select = card.querySelector('select.select');
    var opt = select ? select.options[select.selectedIndex] : null;
    var price = opt ? parseInt(opt.dataset.price || '0', 10) / 100 : 0;
    var variantId = opt ? opt.value : '';
    var variantTitle = opt ? opt.dataset.grammage || '' : '';
    return {
      item_id: variantId,
      item_name: name,
      item_variant: variantTitle || undefined,
      price: price,
      quantity: 1
    };
  }

  // Collection pages: variant selector change
  document.addEventListener('change', function (e) {
    var select = e.target.closest('.product-card__select__container select.select');
    if (!select) return;
    var card = select.closest('.card-wrapper');
    if (!card) return;
    var item = getCardData(card);
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'select_grammage_item',
      item_list_name: 'collection',
      item_name: item.item_name,
      item_id: item.item_id,
      item_variant: item.item_variant,
      price: item.price,
      ecommerce: {
        item_list_name: 'collection',
        items: [item]
      }
    });
  });

  // Homepage: "Choose Options" or quick-add button click
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add__submit');
    if (!btn) return;
    if (window.location.pathname.includes('/collections/')) return;
    var card = btn.closest('.card-wrapper');
    if (!card) return;
    var heading = card.querySelector('.card__heading a');
    var name = heading ? heading.textContent.trim() : '';
    var url = heading ? heading.getAttribute('href') : '';
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'select_grammage_item',
      item_list_name: 'homepage',
      item_name: name,
      item_id: url,
      ecommerce: {
        item_list_name: 'homepage',
        items: [{
          item_name: name,
          item_id: url,
          quantity: 1
        }]
      }
    });
  });
})();
